module.exports = __webpack_public_path__ + "static/vision_text_mobile-9cef902845f8bb74f399063bfcd8b637.svg";